import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import type {FaqCategorySummary} from 'app/utils/knowledgeCenter/faqGrouping';
import {getFaqCategoryIcon} from 'app/utils/knowledgeCenter/categoryIcons';

interface Props {
    categories: FaqCategorySummary[]
}

const KnowledgeCenterCategoryGrid = ({categories}: Props): React.ReactElement => <div className="knowledge-center__category-grid">
    {categories.map(({category, count, label}: FaqCategorySummary) => {
        const iconSrc = getFaqCategoryIcon(category);

        return (
            <Link
                key={category}
                to={getLinkPath(`/faq/category/${category}`)}
                className="knowledge-center__category-card"
            >
                {iconSrc &&
                    <span className="knowledge-center__category-icon">
                        <img
                            className="knowledge-center__category-icon-img"
                            src={iconSrc}
                            alt={label}
                            width={20}
                            height={20}
                            aria-hidden
                        />
                    </span>
                }
                <h3 className="knowledge-center__category-title">
                    {label}
                </h3>
                <p className="knowledge-center__category-meta">
                    {I18n.t('knowledge_center.articles_count', {count})}
                    {' · '}
                    {I18n.t(`knowledge_center.category_descriptions.${category}`)}
                </p>
            </Link>
        );
    })}
</div>;

export default KnowledgeCenterCategoryGrid;
